// Brings the selected variant's photo to the front of the product gallery.
// Listens (delegated) for option changes from <s-variant-picker>, whose markup is
// replaced on every variant switch, and reorders [data-media-id] items with CSS order.
const gallery = document.querySelector('[data-product-gallery]');
const mapScript = document.querySelector('script[type="application/json"][data-variant-media]');

if (gallery && mapScript) {
  let variantMedia = {};
  try {
    // A trailing comma can appear when the last variant has no photo; strip it before parsing.
    variantMedia = JSON.parse(mapScript.textContent.replace(/,\s*}/, '}'));
  } catch {
    variantMedia = {};
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showMedia = (mediaId) => {
    if (!mediaId) return;
    const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (!target) return;

    gallery.querySelectorAll('[data-media-id]').forEach((item) => {
      item.classList.remove('order-first');
      item.style.order = '';
    });
    target.style.order = '-1';

    // Mobile scroller: return to the start so the new lead photo is in view.
    gallery.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    // Desktop: if the gallery top is off-screen, bring it back into view.
    if (window.matchMedia('(min-width: 768px)').matches) {
      const top = gallery.getBoundingClientRect().top;
      if (top < 0) gallery.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (!reduceMotion) {
      target.animate([{ opacity: 0.4 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
    }
  };

  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!(control instanceof HTMLElement) || !control.closest('s-variant-picker')) return;
    const variantId =
      control.dataset.variantId ||
      (control instanceof HTMLSelectElement ? control.selectedOptions[0]?.dataset.variantId : undefined);
    if (variantId) showMedia(variantMedia[variantId]);
  });
}
